module.exports = __webpack_public_path__ + "img/1.66089204.png";